module.exports = __webpack_public_path__ + "static/media/34DSS2.91234aa4.jpg";